<template>
  <div>
    <Button type="text" @click="openModal">{{ address ? address : '点击选择' }}</Button>
    <Modal v-model="showModal" title="地址选择" footer-hide :width="800">
      <div>
        <Button type="default" style="margin-bottom: 10px" @click="showDrawer">新增地址</Button>
        <Table :columns="column" :data="data">
          <template slot-scope="{ row }" slot="city">
            {{ row.province }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <Button type="text" @click="choose(row)" style="margin-right: 5px">选择</Button>
            <Button type="text" @click="edit(row)" style="margin-right: 5px">编辑</Button>
            <Button type="text" @click="del(row)" style="margin-right: 5px">删除</Button>
          </template>
          <Page :current="queryParams.pageIndex" @on-change="changePage" :total="pagination.total" size="small" slot="footer"></Page>
        </Table>
      </div>
    </Modal>
    <Drawer title="地址信息" :width="600" v-model="drawer">
      <Form ref="form" :model="form" :rules="rules" label-position="right" :label-width="80">
        <FormItem label="企业地址" prop="provinceId">
          <Cascader :data="provinces" :value="cities" style="width: 400px" :load-data="loadData" @on-change="changeCity"></Cascader>
        </FormItem>
        <FormItem label="详细地址" prop="address">
          <Input
            v-model="form.address"
            placeholder="选择地址"
            :readonly="!form.latitude"
            @on-click="getSite"
            icon="md-locate"
            style="width: 400px"
          ></Input>
        </FormItem>
        <FormItem label="">
          <Button type="primary" @click="save">保存</Button>
          <Button style="margin-left: 8px" @click="drawer = false">取消</Button>
        </FormItem>
      </Form>
    </Drawer>
    <Drawer title="地图" width="500" :closable="true" :mask-closable="false" v-model="oMap">
      <Map @setSite="setSite"></Map>
    </Drawer>
  </div>
</template>

<script>
import Map from '@/components/map/map';
export default {
  name: '',
  components: { Map },
  props: {
    address: {
      type: String,
      default: () => {
        return '';
      }
    }
  },
  mounted() {
    this.getProvinces();
  },
  data() {
    return {
      form: {},
      rules: {
        provinceId: [{ required: true, message: '省份不能为空', trigger: 'blur' }],
        cityId: [{ required: true, message: '城市不能为空', trigger: 'blur' }],
        address: [{ required: true, message: '地址不能为空', trigger: 'blur' }]
      },
      showModal: false,
      drawer: false,
      column: [
        { title: '省市区', slot: 'city', width: 200 },
        { title: '地址', key: 'address', width: 370 },
        { title: '操作', slot: 'action' }
      ],
      data: [],
      cities: [],
      provinces: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      pagination: {
        total: 0
      },
      oMap: false
    };
  },
  methods: {
    choose(row) {
      this.showModal = false;
      this.$emit('choose', row);
    },
    openModal() {
      this.queryParams.pageIndex = 1;
      this.getList();
      this.showModal = true;
    },
    edit(row) {
      this.form = row;
      this.cities = [row.provinceId, row.cityId, row.districtId, row.streetId];
      this.drawer = true;
    },
    del(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认要删除该地址',
        onOk: () => {
          this._doDel(row.id);
        }
      });
    },
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this._doSave();
        }
      });
    },
    _doDel(id) {
      this.$axios
        .request({
          url: 'front/v1/address',
          method: 'delete',
          data: { ids: [id] }
        })
        .then(res => {
          this.$Message.success('删除成功');
          this.getList();
        });
    },
    _doSave() {
      if (this.form.id) {
        this.$axios
          .request({
            url: 'front/v1/address/' + this.form.id,
            method: 'put',
            data: this.form
          })
          .then(res => {
            this.$Message.success('保存成功');
            this.drawer = false;
            this.getList();
          });
      } else {
        this.$axios
          .request({
            url: 'front/v1/address',
            method: 'post',
            data: this.form
          })
          .then(res => {
            this.$Message.success('保存成功');
            this.drawer = false;
            this.getList();
          });
      }
    },
    showDrawer() {
      this.form = {};
      this.cities = [];
      this.drawer = true;
    },
    getSite() {
      this.oMap = true;
    },
    setSite(e) {
      this.oMap = false;
      this.$set(this.form, 'latitude', e.latlng.lat);
      this.$set(this.form, 'longitude', e.latlng.lng);
      this.$set(this.form, 'address', e.poiaddress);
    },
    changeCity(value) {
      this.cities = value;
      this.$set(this.form, 'provinceId', value[0]);
      this.$set(this.form, 'cityId', value[1]);
      this.$set(this.form, 'districtId', value[2]);
      this.$set(this.form, 'streetId', value[3]);
    },
    getProvinces() {
      this.$axios
        .request({
          url: 'front/v1/area/province',
          method: 'get'
        })
        .then(res => {
          this.provinces = [];
          res.data.forEach(item => {
            this.provinces.push({ value: item.value, label: item.label, children: [], loading: false });
          });
        });
    },
    loadData(item, callback) {
      item.loading = true;
      this.$axios
        .request({
          url: 'front/v1/area/district/' + item.value,
          method: 'get'
        })
        .then(res => {
          item.loading = false;
          item.children = res.data;
          callback();
        });
    },
    changePage(page) {
      this.queryParams.pageIndex = page;
      this.getList();
    },
    getList() {
      this.$axios
        .request({
          url: 'front/v1/address',
          method: 'get',
          params: this.queryParams
        })
        .then(res => {
          this.data = res.data.list;
          this.pagination.total = res.data.count;
        });
    }
  }
};
</script>

<style lang="less" scoped>
::v-deep .ivu-drawer-wrap {
  z-index: 10000;
}
</style>
